if(typeof window.fontkit === 'undefined') { var e = new Error("Cannot find module 'window.fontkit'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = window.fontkit;